import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { API_HEADERS, ENDPOINTS } from '../../constants/api';
import { baseQueryWithAuthCheck } from './helper';
import { callFromMiddleware } from '../../utils';

const baseQuery = fetchBaseQuery({
    baseUrl: window.location.origin,
    headers: API_HEADERS,
    credentials: "include"
});
export const folderManagementApi = createApi({
    reducerPath: 'folderManagement',
    baseQuery: baseQueryWithAuthCheck(baseQuery),
    endpoints: (builder) => ({
      createFolder: builder.mutation({
        query: (payload) => ({
          url: callFromMiddleware(ENDPOINTS.createFolder),
          method: 'POST',
          headers: API_HEADERS,
          body: payload
        }),
      }),
      updateFolder: builder.mutation({
        query: (args) => {
          const encodedFolderName = encodeURIComponent(args.folderName); 
          return {
          url: `${callFromMiddleware(ENDPOINTS.updateFolder)}/${args.folderId}?updateName=${encodedFolderName}`,
          method: 'POST',
          headers: API_HEADERS,
          body: {}
        }},
      }),
      getFolderName : builder.query<any, any>({
        query: (args) => ({
          url: `${callFromMiddleware(ENDPOINTS.getFolderName)}/${args.folderId}`,
          method: "GET",
          headers: API_HEADERS,
        }),
      }),

    }),
})

export const {
    useCreateFolderMutation,
    useUpdateFolderMutation,
    useLazyGetFolderNameQuery
} = folderManagementApi

export default folderManagementApi;
